export const AUTH_REDIRECT = "AUTH_REDIRECT";

export enum UserTypes {
  Volunteers = "volunteers",
  MilalFriends = "milal_friends"
}

export const SERVICE_TYPES = [
  "saturday_agape",
  "orientation",
  "backfill",
  "other"
];

// Auth0 Permissions
export const AUTH0_ADMIN_PERM = "admin";

// Filter constants
export const ACTIVE_FILTER_QUERY = "active=true";